import { render, staticRenderFns } from "./PriceOriginal.vue?vue&type=template&id=3d5a9145&scoped=true&"
import script from "./PriceOriginal.vue?vue&type=script&lang=js&"
export * from "./PriceOriginal.vue?vue&type=script&lang=js&"
import style0 from "./PriceOriginal.vue?vue&type=style&index=0&id=3d5a9145&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a9145",
  null
  
)

export default component.exports